/* eslint-disable */

import { useEffect, useState } from "react";
import {
  createBanner,
  deleteBannerById,
  fetchBanners,
  updateBanner,
  updateBannersPositions,
} from "./api";
import { useSelector } from "react-redux";

export function useBanners() {
  const token = useSelector((state) => state.login.adminInfo.authToken);

  const [banners, setBanners] = useState();

  const fetchList = () =>
    fetchBanners(token).then((res) => {
      setBanners(res.data.data.sort((a, b) => a.position - b.position));
    });

  const updatePositions = (banners) => {
    setBanners(banners);
    const positions = banners.map(({ id }) => id);
    updateBannersPositions(token, positions);
  };

  const deleteBanner = (id) => deleteBannerById(token, id).then(fetchList);

  const create = (formData) => createBanner(token, formData).then(fetchList);
  const update = (id, formData) =>
    updateBanner(token, id, formData).then(fetchList);

  useEffect(() => {
    fetchList();
  }, []);

  const isLoading = !banners;

  return {
    banners,
    isLoading,
    refetch: fetchList,
    updatePositions,
    deleteBanner,
    create,
    update,
  };
}
